<template>
  <div>
    <div class="modal-overlay" @click="closeTestResponseModal" v-if="open"></div>
    <div class="test-response-modal-container" :class="[open ? 'open' : 'closed']">
      {{ testResponse }}
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  props: ["testResponse", "open", "loading"],
  methods: {
    closeTestResponseModal() {
      this.$emit("closeTestResponseModal");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

td,
th {
  padding: 0.7rem;
}

tr {
  border-bottom: 1px solid black;
}

.open {
  opacity: 1;
  top: 50%;
  transition: 0.3s ease-in-out;
}

.closed {
  top: -100%;
  opacity: 0;
  transition: 0.3s ease-in-out;
}

.test-response-modal-container {
  position: fixed;
  z-index: 3;
  left: 50%;
  height: 500px;
  width: 660px;
  text-align: center;
  background: white;
  margin-left: -330px;
  border-radius: 20px;
  margin-top: -250px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

h1 {
  padding: 1rem;
  margin: 0;
  background: lightgrey;
  border-bottom: 1px solid black;
}
</style>
